import produce from 'immer';
import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { SiteStatus, ISiteMetaState } from './types';

const initialState: ISiteMetaState = {
  status: SiteStatus.INITIAL,
  ids: null,
  isCreated: false,
  isBuilt: false,
  isReady: false,
  mediaUploadedToSite: [],
};

function reducer(
  state: ISiteMetaState = initialState,
  action: ActionType<typeof actions>,
): ISiteMetaState {
  return produce(state, (draftState) => {
    switch (action.type) {
      case getType(actions.requestSiteCreate.request):
        draftState.isBuilt = false;
        draftState.isCreated = false;
        draftState.status = SiteStatus.CREATE_REQUEST;
        break;

      case getType(actions.requestSiteCreate.success):
        draftState.ids = action.payload;
        draftState.isCreated = true;
        draftState.status = SiteStatus.CREATE_READY;
        break;

      case getType(actions.requestSiteCreate.failure):
        draftState.status = SiteStatus.CREATE_ERROR;
        break;

      case getType(actions.requestSiteBuild.request):
        draftState.isBuilt = false;
        draftState.status = SiteStatus.BUILD_REQUEST;
        break;

      case getType(actions.requestSiteBuild.success):
        draftState.isBuilt = true;
        draftState.status = SiteStatus.BUILD_READY;
        break;

      case getType(actions.requestSiteBuild.failure):
        draftState.status = SiteStatus.BUILD_ERROR;
        break;

      case getType(actions.setMediaUploaded):
        draftState.mediaUploadedToSite = state.mediaUploadedToSite.concat(
          action.payload,
        );
        break;

      case getType(actions.setSiteIsReady):
        draftState.status = SiteStatus.READY;
        draftState.isReady = true;
        break;

      default:
    }
  });
}

export type { ISiteMetaState };
export default reducer;
